import { LogOut, Moon, Sun, X } from 'lucide-react';
import { THEMES } from '../themes';
import type { ThemeMode } from '../types';

interface Props {
  themeId: string;
  mode: ThemeMode;
  busy: boolean;
  onChange: (themeId: string, mode: ThemeMode) => Promise<void>;
  onClose: () => void;
  onLogout: () => Promise<void>;
}

export function SettingsDialog(props: Props) {
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && props.onClose()}>
      <section className="settings-dialog" role="dialog" aria-modal="true" aria-label="設定">
        <header>
          <h2>設定</h2>
          <button type="button" className="icon-button" onClick={props.onClose} aria-label="關閉"><X size={22} /></button>
        </header>
        <fieldset className="settings-section">
          <legend>顯示模式</legend>
          <div className="mode-segmented">
            <button type="button" className={props.mode === 'system' ? 'active' : ''} onClick={() => props.onChange(props.themeId, 'system')}>系統</button>
            <button type="button" className={props.mode === 'light' ? 'active' : ''} onClick={() => props.onChange(props.themeId, 'light')}><Sun size={17} />淺色</button>
            <button type="button" className={props.mode === 'dark' ? 'active' : ''} onClick={() => props.onChange(props.themeId, 'dark')}><Moon size={17} />深色</button>
          </div>
        </fieldset>
        <fieldset className="settings-section">
          <legend>主題</legend>
          <div className="theme-list">
            {THEMES.map((theme) => (
              <button
                type="button"
                key={theme.id}
                className={`theme-row ${theme.id === props.themeId ? 'selected' : ''}`}
                onClick={() => props.onChange(theme.id, props.mode)}
                disabled={props.busy}
              >
                <span className="theme-swatches">
                  {theme.preview.map((color, index) => <i key={`${color}-${index}`} style={{ backgroundColor: color }} />)}
                </span>
                <span><strong>{theme.label}</strong><small>{theme.description}</small></span>
                <i className="theme-radio" />
              </button>
            ))}
          </div>
        </fieldset>
        <button className="logout-button" type="button" onClick={props.onLogout}><LogOut size={18} />登出此裝置</button>
      </section>
    </div>
  );
}
